import React from 'react';
import { withRouter } from 'react-router';

import { WOMEN_AND_CARDIOVASCULAR_DISEASE_COMMISSION_PATH } from '../../router/paths';

const Footer = props => (
    <footer id="siteFooter" className="site-footer">
        <div className="site-footer__row">
            <div className="site-footer__first-row-wrapper">
                <div className="site-footer__fr-left justify-content-between align-items-center">
                    <a
                        href={WOMEN_AND_CARDIOVASCULAR_DISEASE_COMMISSION_PATH}
                        className="logo site-footer__logo"
                    >
                        <img
                            src="https://womencvdcommission.org/wp-content/themes/cvd-theme/dist/images/logo.png"
                            alt="Women And Cardiovascular Disease Commission"
                            className="site-logo__image"
                        />
                    </a>
                    <p className="footer-copy mb-2 flex-grow-1 text-center">Reducing the Global Burden by 2030</p>
                    <a
                        href="https://www.thelancet.com/journals/lancet/article/PIIS0140-6736(21)00684-X/fulltext?dgcid=commweb_resources_lancetwomencvd21"
                        className="site-footer__button"
                        target="_blank"
                    >
                        VIEW THE LANCET COMMISSION REPORT
                    </a>
                </div>
            </div>
        </div>
        <div className="site-footer__second-row-wrapper" />
    </footer>
);

export default withRouter(Footer);
